import { render, staticRenderFns } from "./History.vue?vue&type=template&id=d1be5a68&scoped=true"
import script from "./History.vue?vue&type=script&lang=ts"
export * from "./History.vue?vue&type=script&lang=ts"
import style0 from "./History.vue?vue&type=style&index=0&id=d1be5a68&prod&lang=scss&scoped=true"
import style1 from "./History.vue?vue&type=style&index=1&id=d1be5a68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1be5a68",
  null
  
)

export default component.exports